import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';

const messages = defineMessages({
  SelectAValue: 'Select a value',
});

class PriceGridSelector extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    value: PropTypes.string,
  };
  static defaultProps = {
    value: null,
    required: false,
    placeholder: null,
  };

  state = {
    items: [],
  };

  componentDidMount() {
    const { intl } = this.props;
    api.base.get(`${config.appUrls.api}/api/price/Grid`).then(({ data }) => {
      this.setState({
        items: (data || [])
          .sort(dynamicSort('name')),
      });
    });
  }

  selectedValueChanged(e) {
    const { onChange } = this.props;
    onChange(e.target.value || null);
  }

  render() {
    const { intl, placeholder, required, value } = this.props;
    const { items } = this.state;
    return (
      <select value={value} className="form-control" onChange={e => this.selectedValueChanged(e)}>
        {(!required || !value) && (
          <option value="">{placeholder ?? intl.formatMessage(messages.SelectAValue)}</option>
        )}
        {items &&
          items.map(item => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
      </select>
    );
  }
}

export default injectIntl(PriceGridSelector);
